import { render, staticRenderFns } from "./addRecycler.vue?vue&type=template&id=566e7d0d&scoped=true&"
import script from "./addRecycler.vue?vue&type=script&lang=js&"
export * from "./addRecycler.vue?vue&type=script&lang=js&"
import style0 from "./addRecycler.vue?vue&type=style&index=0&id=566e7d0d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e7d0d",
  null
  
)

export default component.exports